import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

export default function DriverDay() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`/api/public/driver/${token}`)
      .then(({ data: d }) => setData(d))
      .catch((err) => setError(err.response?.data?.error || 'הקישור אינו תקף'));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="bg-white rounded-2xl shadow p-8 text-red-600">{error}</div>
      </div>
    );
  }
  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-nexolog-teal" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-nexolog-navy text-white py-4 px-4">
        <div className="max-w-2xl mx-auto">
          <div className="text-2xl font-bold"><span style={{ color: '#1DBFAF' }}>Nexolog</span></div>
          <div className="text-sm text-gray-300">איסופים ליום {data.day_fmt}</div>
          <div className="font-semibold">{data.driver}</div>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 py-6 space-y-3">
        <p className="text-sm text-gray-600">{data.stops.length} עצירות</p>
        {data.stops.map((s, i) => (
          <article key={i} className="bg-white rounded-xl shadow p-4">
            <div className="font-bold text-nexolog-navy">{i + 1}. {s.address || 'כתובת חסרה'}</div>
            <div className="text-sm text-gray-700">{s.destination_recipient}</div>
            <div className="text-sm text-gray-600">{s.company_name}</div>
            {s.wp_order_id && <div className="text-xs text-gray-500">הזמנה {s.wp_order_id}</div>}
            {s.floor && <div className="text-sm">קומה {s.floor}</div>}
            {s.notes && <div className="text-sm bg-amber-50 rounded-lg p-2 mt-2">{s.notes}</div>}
            {s.porterage_total != null && (
              <div className="text-sm font-semibold mt-1">סבלות: {s.porterage_total} ₪</div>
            )}
          </article>
        ))}
        {data.stops.length === 0 && (
          <div className="bg-white rounded-xl shadow p-6 text-center text-gray-500">אין איסופים ליום זה</div>
        )}
      </main>
    </div>
  );
}
